// ../const/function/data.ts
var ToStringCallEnum = {
  Object: "[object Object]",
  Array: "[object Array]",
  String: "[object String]",
  Number: "[object Number]",
};

// ../function/data/object.ts
function getDeepCloneProperty(record) {
  let result = record;
  if (record) {
    const toStringValue = Object.prototype.toString.call(record);
    if (
      toStringValue === ToStringCallEnum.Object ||
      toStringValue === ToStringCallEnum.Array
    ) {
      if (toStringValue === ToStringCallEnum.Object) {
        result = {};
      } else if (toStringValue === ToStringCallEnum.Array) {
        result = [];
      }
      const keys = Object.keys(record);
      for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        if (key) {
          result[key] = getDeepCloneProperty(record[key]);
        }
      }
    }
  }
  return result;
}

// ComponentClass.ts
function arrayBufferToString(buffer) {
  return new TextDecoder("utf-8").decode(buffer);
}
var CompressImageOptionsClass = class {
  constructor(data = {}) {
    this.classPrefix = "compressImageOptions";
    this.imageData = "";
    this.imagePath = "";
    /** 超出大小才压缩 */
    this.maxSize = 1 * 1024 * 1024;
    this.width = 0;
    this.height = 0;
    this.quality = 0.7;
    this.resultType = "File";
    this.handleHttpRequestResult = (result) => {
      if (!result) {
        console.error("\u4E0A\u4F20\u56FE\u7247\u5931\u8D25\uFF01");
      }
    };
    Object.assign(this, data);
  }
};
var CompressImageClass = class _CompressImageClass {
  /**
   * 压缩文件格式或base64图片，返回文件
   * @param {*} compressImageOptionsArg
   * @returns File
   */
  async compressImage(compressImageOptionsArg) {
    const targetCompressImageOptions = new CompressImageOptionsClass(
      compressImageOptionsArg
    );
    let result = "";
    if (targetCompressImageOptions) {
      const imageData = targetCompressImageOptions.imageData;
      if (imageData) {
        let imageFileBase64 = "";
        if (typeof imageData !== "string") {
          imageFileBase64 = await this.toBase64(imageData);
        } else {
          imageFileBase64 = imageData;
        }
        targetCompressImageOptions.imagePath = imageFileBase64;
        result = await this.compressedImageBase64(targetCompressImageOptions);
        if (result && result.length > 1e3) {
          if (targetCompressImageOptions.resultType === "File") {
            const fileName =
              typeof imageData !== "string"
                ? imageData.name
                : `\u538B\u7F29\u540E\u7684\u56FE\u7247${Date.now()}`;
            const bolbResult = this.dataURLtoBlob(result);
            result = this.blobToFile(bolbResult, fileName);
          }
        } else {
          result = imageData;
        }
      }
    }
    return result;
  }
  /**
   * 按比例缩放图片到宽度和高度都3000以内
   * @param {Object} imgOnloadThisArg
   */
  scaleWidthAndHeightProportionally(imgOnloadThisArg, maxWidthHiehgt = 3e3) {
    let resultWidth = 0;
    let resultHeight = 0;
    if (imgOnloadThisArg) {
      resultWidth = imgOnloadThisArg.width;
      resultHeight = imgOnloadThisArg.height;
      let i = 0;
      while (
        (resultWidth > maxWidthHiehgt || resultHeight > maxWidthHiehgt) &&
        i++ < 10
      ) {
        resultWidth /= 2;
        resultHeight /= 2;
      }
    }
    return { width: resultWidth, height: resultHeight };
  }
  /**
   * 转base64
   * @param {*} imageFileArg
   * @returns
   */
  async toBase64(imageFileArg) {
    let resolveFunction = (value) => {};
    const result = new Promise((resolve) => {
      resolveFunction = resolve;
    });
    let isReadFile = false;
    if (imageFileArg) {
      const fileReaderInstance = new FileReader();
      fileReaderInstance.readAsDataURL(imageFileArg);
      fileReaderInstance.onload = function () {
        let resolveValue = "";
        if (this.result) {
          resolveValue =
            typeof this.result === "string"
              ? this.result
              : arrayBufferToString(this.result);
        }
        resolveFunction(resolveValue);
      };
      fileReaderInstance.onerror = function (error) {
        console.warn("fileReaderInstance.onerror", error);
        resolveFunction("");
      };
      isReadFile = true;
    }
    if (!isReadFile) {
      resolveFunction("");
    }
    return result;
  }
  // 计算base64编码图片大小
  getBase64ImageSize(base64) {
    const indexBase64 = base64.indexOf("base64,");
    if (indexBase64 < 0) {
      return -1;
    }
    const str = base64.substr(indexBase64 + 6);
    return Number((str.length * 0.75).toFixed(2));
  }
  /**
   * 压缩base64格式图片，返回base64
   * @param {*} compressImageOptionsArg
   * @returns
   */
  compressedImageBase64(compressImageOptionsArg) {
    let resolveFunction = (value) => {};
    const result = new Promise((resolve) => {
      resolveFunction = resolve;
    });
    let img = new Image();
    img.src = compressImageOptionsArg.imagePath;
    img.onload = async function () {
      const that = this;
      const { width, height } =
        new _CompressImageClass().scaleWidthAndHeightProportionally(that);
      let w = width;
      let h = height;
      let scale = w / h;
      w = compressImageOptionsArg.width || w;
      h =
        (compressImageOptionsArg.height &&
          compressImageOptionsArg.height * (w / scale)) ||
        h;
      let canvas = document.createElement("canvas");
      let ctx = canvas.getContext("2d");
      canvas.width = w;
      canvas.height = h;
      if (ctx) {
        ctx.drawImage(that, 0, 0, w, h);
      }
      let newBase64Image = canvas.toDataURL(
        "image/jpeg",
        compressImageOptionsArg.quality
      );
      let fileSize = new _CompressImageClass().getBase64ImageSize(
        newBase64Image
      );
      if (
        compressImageOptionsArg.maxSize > 1e3 &&
        fileSize > compressImageOptionsArg.maxSize &&
        compressImageOptionsArg.quality > 0.01
      ) {
        compressImageOptionsArg.quality = compressImageOptionsArg.quality / 2;
        newBase64Image = await new _CompressImageClass().compressedImageBase64(
          compressImageOptionsArg
        );
      }
      resolveFunction(newBase64Image);
    };
    img.onerror = function (error) {
      console.warn("compressedImageBase64 img.onerror", error);
      resolveFunction("");
    };
    return result;
  }
  /**
   * 1,先将base64转换为blob
   * @param {*} dataurl
   * @returns
   */
  dataURLtoBlob(dataurl) {
    let u8arr = new Uint8Array();
    let mime = "";
    let arr = dataurl.split(",");
    if (arr[0]) {
      const matchResult = arr[0].match(/:(.*?);/);
      if (matchResult) {
        mime = matchResult[1] || "";
        let bstr = atob(arr[1] || "");
        let n = bstr.length;
        u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
      }
    }
    return new Blob([u8arr], { type: mime });
  }
  /**
   * 2,再将blob转换为file
   * @param {*} theBlob
   * @param {*} fileName
   * @returns
   */
  blobToFile(theBlob, fileName) {
    theBlob.lastModifiedDate = /* @__PURE__ */ new Date();
    theBlob.name = fileName;
    return new File([theBlob], fileName, {
      type: theBlob.type,
      lastModified: Date.now(),
    });
  }
  /**
   * ep-upload组件-覆盖默认的上传行为，可以自定义上传的实现
   * @param {*} options
   * @param {*} compressImageOptionsArg
   * @returns
   */
  async elUploadHttpRequest(options, compressImageOptionsArg = {}) {
    let result = {};
    try {
      const targetCompressImageOptions = new CompressImageOptionsClass(
        compressImageOptionsArg
      );
      if (options) {
        const uploadFile = getDeepCloneProperty(options.file);
        if (
          uploadFile &&
          uploadFile.size > targetCompressImageOptions.maxSize
        ) {
          options.file = await new _CompressImageClass().compressImage({
            ...targetCompressImageOptions,
            imageData: uploadFile,
          });
          if (options.file) {
            options.file.remark = uploadFile.remark;
            options.file.uid = uploadFile.uid;
          }
        }
      }
    } catch (error) {
      result = {};
      console.warn("ComponentClass.js elUploadHttpRequest", error);
    }
    return result;
  }
};
var FormUploadClass = class {
  // items.length比较有意思，初步判断是根据mime类型来的，即有几种mime类型，长度就是几（待验证）
  // 如果粘贴纯文本，那么len=1，如果粘贴网页图片，len=2, items[0].type = 'text/plain', items[1].type = 'image/*'
  // 如果使用截图工具粘贴图片，len=1, items[0].type = 'image/png'
  // 如果粘贴纯文本+HTML，len=2, items[0].type = 'text/plain', items[1].type = 'text/html'
  /**
   * 处理粘贴的内容，返回File类型
   * @param {*} event
   */
  // handlePaste(event: ClipboardEvent & { originalEvent: { clipboardData: DataTransfer } }) {
  //   let result = [];
  //   if (event.clipboardData || event.originalEvent) {
  //     // not for ie11  某些chrome版本使用的是event.originalEvent
  //     let clipboardData = event.clipboardData || event.originalEvent.clipboardData;
  //     if (clipboardData.items) {
  //       // for chrome
  //       let items = clipboardData.items;
  //       let len = items.length;
  //       // 阻止默认行为即不让剪贴板内容在div中显示出来
  //       event.preventDefault();
  //       // 在items里找粘贴的image,据上面分析,需要循环
  //       for (let i = 0; i < len; i++) {
  //         if (items[i].type.indexOf('image') !== -1) {
  //           // getAsFile() 此方法只是living standard firefox ie11 并不支持
  //           result.push(items[i].getAsFile());
  //         }
  //       }
  //     }
  //   }
  //   return result;
  // }
  /**
   * 使用 fetch 请求图片并将其转换为 File 类型
   * @param url
   * @param filename
   * @param mimeType
   * @returns
   */
  async urlToFile(url, filename, mimeType) {
    let result = null;
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      result = new File([blob], filename, { type: mimeType || blob.type });
    } catch (error) {
      console.warn("urlToFile error", error);
    }
    return result;
  }
  /**
   * 如果 fetch 受到跨域限制，可以使用 canvas 来转换图片：
   * @param url
   * @param filename
   * @returns
   */
  async imageToFileUsingCanvas(url, filename) {
    const img = new Image();
    img.crossOrigin = "Anonymous";
    img.src = url;
    return new Promise((resolve, reject) => {
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        if (ctx) {
          ctx.drawImage(img, 0, 0);
          canvas.toBlob((blob) => {
            if (blob) {
              resolve(new File([blob], filename, { type: blob.type }));
            } else {
              reject(new Error("Canvas conversion failed"));
            }
          }, "image/png");
        } else {
          reject(new Error("Canvas ctx is null"));
        }
      };
      img.onerror = () => reject(new Error("Image load error"));
    });
  }
  /**
   * 如果 fetch 受到跨域限制，可以使用 canvas 来转换图片：
   * @param url
   * @param filename
   * @returns
   */
  async canvasUrlToFile(url, filename) {
    let result = null;
    try {
      result = await this.imageToFileUsingCanvas(url, filename);
    } catch (error) {
      console.warn("canvasUrlToFile error", error);
    }
    return result;
  }
};

console.log("ComponentClass.js--------------------------------------");
